import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "d-flex h-100 flex-column intranet" };
const _hoisted_2 = { class: "p-4 h-100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_intranet_layout__footer = _resolveComponent("g-intranet-layout__footer");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
        ]),
        _createVNode(_component_g_intranet_layout__footer)
    ]));
}
